// extracted by mini-css-extract-plugin
module.exports = {"results":"styles_results__IYppF","results__list":"styles_results__list__yGxW8"};